import React, { useState, useMemo } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { CheckCircleFilled, ExclamationCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { debounce } from 'lodash';
import './index.less';

const defaultLabelCol = {
  labelCol: {
    flex: '80px',
    style: {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-all',
      width: '100%',
    },
  },
  labelAlign: 'left',
  wrapperCol: { flex: 1 },
};

export default function CommonAddErpModal(props) {
  const {
    /* *** 中间层卡控属性 *** */
    visible,
    onMidwareModalOk,
    onMidwareModalCancel,

    /* *** 顶层透传下来的属性 *** */
    title = '新增人员',
    extraTitle,
    extraDis,
    successMsg,
    placeholder,
    resNoShowAddTxt = false,
    ...othersProps
  } = props;
  const [modalForm] = Form.useForm();
  const [addErpUserRes, setAddErpUserRes] = useState(null);

  /* ************************************************************************************
   *                                  【【 响应添加成果 】】                                *
   ************************************************************************************* */
  /* ***** ！！！！【注意一定是ret==='0'时的数据，ret!=='0'业务方自己报错】！！！！ ***** */
  const memoizedAddErpRes = useMemo(() => {
    if (!addErpUserRes) return null;
    const { success = null, failure = null, reasons = null } = addErpUserRes;
    if (!success && !failure) return null;

    if (success && success > 0 && (!failure || (failure && failure == 0))) {
      // 只有成功的
      message.success(`${successMsg || (resNoShowAddTxt ? '成功' : '添加成功')}！`);
    } else if (failure && failure > 0 && (!success || (success && success == 0))) {
      // 只有失败的
      return (
        <div className="ty-common-add-erp-res-fa">
          <div className="add-erp-res-sum">
            <span className="add-erp-res-sum-icon">
              <CloseCircleFilled className="error-icon sum-icon" />
            </span>
            <span className="add-erp-res-sum-txt">
              {resNoShowAddTxt ? '' : '添加'}失败{failure}个
            </span>
          </div>
          <div className="add-erp-error-list-fa">
            {reasons && Array.isArray(reasons) && reasons.length > 0
              ? reasons.map((item, index) => {
                  return (
                    <div className="add-erp-error-item" key={index}>
                      {item?.reason && <span className="add-erp-error-reason">{item?.reason}：</span>}
                      <span className="add-erp-error-erps">{item?.erps || '-'}</span>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      );
    } else {
      // 成功和失败都有的
      return (
        <div className="ty-common-add-erp-res-fa">
          <div className="add-erp-res-sum">
            <span className="add-erp-res-sum-icon">
              <ExclamationCircleFilled className="warning-icon sum-icon" />
            </span>
            <span className="add-erp-res-sum-txt">
              {resNoShowAddTxt ? '' : '添加'}成功{success || '0'}个，{resNoShowAddTxt ? '' : '添加'}失败{failure || '0'}
              个
            </span>
          </div>
          <div className="add-erp-error-list-fa">
            {reasons && Array.isArray(reasons) && reasons?.length > 0
              ? reasons.map((item, index) => {
                  return (
                    <div className="add-erp-error-item" key={index}>
                      {item?.reason && <span className="add-erp-error-reason">{item?.reason}：</span>}
                      <span className="add-erp-error-erps">{item?.erps || ''}</span>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      );
    }
  }, [addErpUserRes, successMsg, resNoShowAddTxt]);

  /* ************************************************************************************
   *                                  【【 回抛事件 】】                                   *
   ************************************************************************************* */
  /* ********************* 【action】提交表单，添加erp ********************* */
  async function handleInlineOk() {
    try {
      // 1、默认form的值
      const defaulRres = await modalForm.validateFields();
      let erpsStr = defaulRres?.erps || '';
      erpsStr = erpsStr && typeof erpsStr === 'string' && erpsStr?.trim();
      erpsStr = erpsStr?.replace(/，/gi, ','); //替换所有的中文逗号为英文逗号
      erpsStr = erpsStr?.replace(/[\r\n]/g, ','); //替换所有的换行符为英文逗号
      erpsStr = erpsStr?.replace(/\s+/g, ','); //替换所有的空格符为英文逗号
      // 去掉为空的元素
      erpsStr = erpsStr
        ?.split(',')
        ?.filter((item) => (item ?? '') !== '')
        ?.join(',');

      // 重新赋值
      defaulRres.erps = erpsStr;

      // 3、合并输出
      onMidwareModalOk && typeof onMidwareModalOk === 'function' && onMidwareModalOk(defaulRres, successCallBack);
    } catch (error) {
      console.log(error);
    }
    // 4、点击添加按钮后 不管成功与否 清空输入框里面的内容后,重置Form
    modalForm && modalForm.resetFields();
  }

  /* 业务放接口调用成功以后的回调数据【根据回调数据绝对渲染的UI】 */
  function successCallBack(successBackData) {
    setAddErpUserRes(successBackData);
  }

  /* ********************* 【action】点击modal的cancel回调 ********************* */
  function handleInlineCancel(e) {
    onMidwareModalCancel && typeof onMidwareModalCancel === 'function' && onMidwareModalCancel(e);
    modalForm && modalForm.resetFields();
    setAddErpUserRes(null);
  }

  /* ********************* 【action】handleInlineAfterClose,防止外围主动调用close时没有清空数据 ********************* */
  function handleInlineAfterClose() {
    modalForm && modalForm.resetFields();
    setAddErpUserRes(null);
  }

  return (
    <Modal
      okText="确认"
      cancelText="取消"
      className="ty-common-add-erp-modal"
      bodyStyle={{ paddingTop: '16px', paddingBottom: '16px', maxHeight: '622px', overflow: 'hidden auto' }}
      title={title}
      visible={visible}
      onOk={debounce(handleInlineOk, 200)}
      onCancel={debounce(handleInlineCancel, 200)}
      afterClose={handleInlineAfterClose}
    >
      {/* 拓展标题区 */}
      {extraTitle || extraDis ? (
        <div className="ty-common-extra-content-fa">
          <div className="extra-title-fa">{extraTitle}</div>
          <div className="extra-extraDis-fa">{extraDis}</div>
        </div>
      ) : null}

      {/* 表单区 */}
      <Form form={modalForm} {...defaultLabelCol}>
        <Form.Item
          name="erps"
          label={
            <span>
              <span style={{ color: '#ff4d4f', marginRight: '2px' }}>*</span>
              erp账号
            </span>
          }
          style={{ marginBottom: '0px' }}
        >
          <Input.TextArea
            placeholder={placeholder || '输入多个ERP账号请以英文逗号或者空格区分'}
            style={{ height: 98 }}
          />
        </Form.Item>
      </Form>

      {/* 报错展示区域 */}
      {memoizedAddErpRes}
    </Modal>
  );
}
